export default __webpack_public_path__ + "static/mobileTerminal-77c82012f9447186d58c0a48e702a655.svg";